// src/config/featureFlags.js
//
// ADMIN-NAV-FEATURE-TOGGLES: Nav feature flags are now DB-driven.
// This module re-exports the hook and defaults from FeatureFlagContext.
//
// For components that gate on nav flags:
//   const flags = useFeatureFlags();
//   if (!flags.FEATURE_PULSE_NAV) { ... }
//
// Non-nav flags (tab-level, not in the admin panel) remain as static constants.

export { useFeatureFlags, DEFAULT_FLAGS } from "../contexts/FeatureFlagContext.jsx";

// ─── Non-nav feature flags (static; not admin-panel-managed) ──────────────────

// COST-TAB-BUILD: Cost tab enabled. Backed by location_opex + GET /api/locations/:id/opex.
export const FEATURE_LOCATION_COST_TAB = true;

// Phase 1 MVP scope: Lease Intelligence section hidden from Lease tab.
// Re-enable for Phase 2 by flipping to true. No other code change required.
export const FEATURE_LEASE_INTELLIGENCE = false;

// ADMIN-DATA-RATIONALIZE: DataHealth tab hidden until the view is production-ready.
// Flip to true to bring it back; the component and route are untouched.
export const SHOW_DATA_HEALTH = false;

// PDF-ABSTRACTION-GATE: key in the feature_flags DB table and in DEFAULT_FLAGS.
// When false, the PDF source-type option is hidden in the import picker and
// auto-detected PDF files fall back to manual_csv.
export const FEATURE_PDF_ABSTRACTION = "pdf_abstraction";

// PRE-LAUNCH-PREVIEW: Admin-managed app-open notice, enabled until launch date.
export const FEATURE_PRELAUNCH_PREVIEW = "pre_launch_preview";
